import { Dayjs } from 'dayjs';

export const dateAsNumber = (day: Dayjs): number => {
    const date = String(day.date()).padStart(2, '0');
    const month = String(day.month() + 1).padStart(2, '0');
    return Number(`${day.year()}${month}${date}`);
};

export const priceAsNumber = (price: number | string | null | undefined): number =>
    !price || isNaN(+price) ? 0 : +price;

export const priceToFixed = (price: number | null | undefined) => {
    if (price === 0) {
        return price;
    }
    return price && price.toFixed(2);
};
